module.exports = __webpack_public_path__ + "static/media/Technopark-logo.905d02be.svg";